import styled from "styled-components";

export const Titulo = styled.div`
    width: 100%;
    overflow: hidden;
    min-height: 31.25rem;
    h1 {
        padding-top: 8.781rem;
        font-family: "ubuntu";
        font-weight: bold;
        color: #fff;
        font-size: clamp(1.063rem, 2.5vw, 2.5rem);
        line-height: 46px;
        text-align: center;
        position: absolute;
        left: calc(50vw - 7.025rem);
        text-transform: uppercase;
    }
    picture > img {
        overflow: hidden;
        position: absolute;
        object-fit: cover;
        width: 100%;
        min-height: 38.438rem;
        margin-top: 6.469rem;
        z-index: -1000;
    }
    @media (max-width: 48em) {
        min-height: 16.688rem;
        h1 {
            padding-top: 4.781rem;
        }
        picture > img {
            overflow: hidden;
            position: absolute;
            object-fit: cover;
            width: 100%;
            min-height: 12.688rem;
            margin-top: 4.781rem;
            z-index: -1000;
        }
    }
`;

export const Beneficios = styled.div`
    background-color: #da3832;
    .boxes {
        display: flex;
        justify-content: center;
        position: relative;
        top: -11.875rem;
        .box {
            width: 360px;
            height: 360px;
            text-align: center;
            padding-top: 80px;
            h1 {
                font-family: "Ubuntu";
                font-weight: bold;
                color: #fff;
                font-size: clamp(1.063rem, 2.5vw, 2.5rem);
                line-height: 46px;
                margin-top: 20px;
            }
        }

        .saude {
            background-color: #b12e29;
            :hover .off-saude {
                display: initial;
            }
            :hover .on-saude {
                display: none;
            }
            .off-saude {
                display: none;
                p {
                    font-family: "Ubuntu";
                    font-weight: bold;
                    color: #fff;
                    font-size: 20px;
                    line-height: 24px;
                    text-align: initial;
                    width: 80%;
                    margin: 0 auto;
                }
            }
        }

        .educacao {
            background-color: #7b1d1a;
            :hover .off-educacao {
                display: block;
            }
            :hover .on-educacao {
                display: none;
            }
            .off-educacao {
                display: none;
                p {
                    font-family: "Ubuntu";
                    font-weight: bold;
                    color: #fff;
                    font-size: 20px;
                    line-height: 24px;
                    text-align: initial;
                    width: 80%;
                    margin: 0 auto;
                }
            }
        }
        .lazer {
            background-color: #3e0d0c;
            :hover .off-lazer {
                display: block;
            }
            :hover .on-lazer {
                display: none;
            }
            .off-lazer {
                display: none;
                p {
                    font-family: "Ubuntu";
                    font-weight: bold;
                    color: #fff;
                    font-size: 20px;
                    line-height: 24px;
                    text-align: initial;
                    width: 80%;
                    margin: 0 auto;
                }
            }
        }
    }
    @media (max-width: 48rem) {
        .boxes {
            top: -6.75rem;
            .box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding-top: 0;
                width: 6.25rem;
                height: 6.25rem;
                img {
                    width: 51%;
                }
                h1 {
                    margin-top: 0.5rem;
                    font-size: 0.563rem;
                    line-height: 0.625rem;
                }
                .on-educacao {
                    img {
                        width: 41%;
                    }
                }
                .off-educacao {
                    display: block;
                }
                .on-lazer {
                    img {
                        width: 81%;
                    }
                }
            }
            div[class*="off-"] {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 auto;
                text-align: left;
                position: absolute;
                width: 18.75rem;
                height: 7.75rem;
                background-color: rgba(177, 46, 41, 1);
                top: 6.26rem;
                left: calc(50% - 9.375rem);
                p {
                    margin: 0 auto !important;
                    margin-top: 1rem !important;
                    font-size: 0.875rem !important;
                    line-height: 1rem !important;
                }
            }
            .lazer {
                .off-lazer {
                    display: block;
                    /* right: 12.5rem; */
                }
                :hover .on-lazer {
                    display: block;
                }
            }
            .educacao {
                .off-educacao {
                    display: block;
                    /* right: 6.25rem; */
                }
                :hover .on-educacao {
                    display: block;
                }
            }
            .saude {
                .off-saude {
                    display: block;
                }
                :hover .on-saude {
                    display: block;
                }
            }
        }
    }
`;

export const Descontos = styled.div`
    background-color: #da3832;
    h1 {
        font-family: "ubuntu";
        font-weight: bold;
        color: #fff;
        font-size: 40px;
        line-height: 46px;
        text-align: center;
        text-transform: uppercase;
        margin-bottom: 40px;
        @media (max-width: 48rem) {
            font-size: 1.063rem;
            line-height: 1.188rem;
        }
    }
    .especiais {
        background-color: #b12e29;
        display: grid;
        padding: 0 45px;
        height: 360px;
        grid-template-columns: 240px auto;
        grid-gap: 56px;
        align-items: center;
        max-width: 1020px;
        margin: 0 auto;
        margin-top: 20px;

        img {
            max-width: 100%;
        }
        h4 {
            font-family: "ubuntu";
            font-weight: bold;
            color: #f6d617;
            font-size: 40px;
            line-height: 46px;
            text-transform: uppercase;
        }
        p {
            font-family: "ubuntu";
            font-weight: bold;
            color: #fff;
            font-size: 30px;
            line-height: 35px;
        }
        @media (max-width: 768px) {
            grid-template-columns: 85px auto;
            grid-gap: 16px;
            height: auto;
            padding: 20px 12px;
            h4 {
                font-size: 18px;
                line-height: 21px;
            }
            p {
                font-size: 14px;
                line-height: 16px;
            }
        }
    }
`;
